import React, { useRef, useState } from "react";
import { Button, Form } from "react-bootstrap";
// import AsyncSelect from "react-select/async";
// import { getPatients } from "./services/report-service";
import { Card, CardTitle, CardBody, Input } from "reactstrap";
import { uploadInvoiceService } from "../SearchPatient/services/search-patient";
import { toast } from "react-toastify";
import SearchPatientModel from "../SearchPatient/SearchPatientModal";
import { InputGroup } from "react-bootstrap";
import moment from "moment";
import { FiPhoneCall } from "react-icons/fi";
import { TfiEmail } from "react-icons/tfi";
import { FaLocationDot } from "react-icons/fa6";
import errorProfile from "../.././assets/images/blank_profile.png";
import S3ImageLoader from "../../S3ImageLoader";
const imageBaseURL = process.env.REACT_APP_BASE_URL;

// const selectStyles = {
//   menuPortal: (base) => ({ ...base, zIndex: 9999 }),
//   control: (base) => ({ ...base, minHeight: "38px" }),
// };

const NewReport = () => {
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [file, setFile] = useState(null);
  const [errors, setErrors] = useState({});
  const [isUploading, setIsUploading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [isPatientModal, setIsPatientModal] = useState(false);

  const fileInputRef = useRef(null);

  // Load patients based on search input
  // const loadPatients = async (inputValue) => {
  //   if (!inputValue || inputValue.length < 3) {
  //     return [];
  //   }

  //   const body = {
  //     search: inputValue,
  //   };

  //   try {
  //     const response = await getPatients(body);
  //     const patients = response.data.data.patients || [];
  //     return patients.map((patient) => ({
  //       value: patient._id,
  //       label: patient.full_name,
  //       data: patient,
  //     }));
  //   } catch (error) {
  //     console.error("Error searching patients:", error);
  //     return [];
  //   }
  // };

  const onSubmit = async (e) => {
    e.preventDefault();
    let formErrors = {};
    if (!selectedPatient) formErrors.patient = "Patient is required.";
    if (!file) formErrors.file = "Report file is required.";

    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      return;
    }
    setErrors({});
    const formData = new FormData();
    formData.append("patient_id", selectedPatient._id);
    formData.append("document", file);

    setIsUploading(true);
    try {
      const res = await uploadInvoiceService(formData);
      if (res.data.status === "success") {
        toast.success("Report Uploaded Successfully");
        setErrors({});
        setFile(null);
        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
      } else {
        console.log(res);
      }
    } catch (error) {
      console.error("Error while uploading report", error);
    } finally {
      setIsUploading(false);
    }
  };

  const resetReport = () => {
    setSelectedPatient(null);
    setFile(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const handleSearchClick = () => {
    if (searchQuery.trim().length >= 3) {
      setIsPatientModal(true);
    } else {
      toast.warning("Please enter at least 3 characters to search");
    }
  };

  const handleSearchKeyPress = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleSearchClick();
    }
  };

  const calculateAge = (birthDate) => {
    const birthDateMoment = moment(birthDate); // Parse the birth date
    const currentDate = moment(); // Get the current date
    // Calculate the difference in years
    const age = currentDate.diff(birthDateMoment, "years");
    return age;
  };

  return (
    <Card>
      <CardBody>
        <CardTitle tag="h3" className="tw-font-bold">
          Add Report
        </CardTitle>
        {isUploading && (
          <div
            className="top-0 position-absolute start-0 w-100 h-100 d-flex flex-column justify-content-center align-items-center"
            style={{
              backgroundColor: "rgba(255, 255, 255, 0.7)",
              zIndex: 1050,
            }}
          >
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Uploading...</span>
            </div>
            <div className="mt-3 text-primary">
              Extracting details from report...
            </div>
          </div>
        )}

        <Form onSubmit={onSubmit} className="p-3">
          {/* Patient*/}
          <Form.Group className="mb-3">
            <Form.Label>Patient</Form.Label>
            <InputGroup className="custom-input-group">
              <Input
                type="search"
                className="search-bar patient-search-bar tw-rounded-s-full"
                placeholder="Search Patient by NAKBHO ID / Name / Email / Phone"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                onKeyPress={handleSearchKeyPress}
              />
              <InputGroup.Text
                onClick={handleSearchClick}
                className="text-white patient-search-icon-btn tw-rounded-e-full"
                style={{ backgroundColor: "var(--theme-default)", background:
                      "linear-gradient(180.05deg, #006E27 20.14%, #033415 87.13%)" }}
              >
                <i
                  className="fa fa-search"
                  style={{ fontSize: "14px", height: "22px", width: "16px" }}
                ></i>
              </InputGroup.Text>
            </InputGroup>
            {/* <AsyncSelect
              cacheOptions
              defaultOptions
              loadOptions={loadPatients}
              value={
                selectedPatient
                  ? {
                      value: selectedPatient._id,
                      label: selectedPatient.full_name,
                      data: selectedPatient,
                    }
                  : null
              }
              onChange={(selectedOption) => {
                const patient = selectedOption ? selectedOption.data : null;
                setSelectedPatient(patient);
              }}
              placeholder="Search patient by name or phone..."
              noOptionsMessage={({ inputValue }) =>
                inputValue.length < 3
                  ? "Type at least 3 characters"
                  : "No patients found"
              }
              styles={{
                ...selectStyles,
                control: (base) => ({
                  ...base,
                  minHeight: "38px",
                  width: "100%",
                }),
              }}
              isClearable
              menuPortalTarget={document.body}
              menuShouldScrollIntoView={true}
              isDisabled={isUploading}
            /> */}
            {errors.patient && (
              <div className="mt-1 text-danger">{errors.patient}</div>
            )}
          </Form.Group>

          {selectedPatient && (
            <>
              {/* <Row className="tw-my-3">
                <h3>Patient Details</h3>
                <Col sm="6">
                  <p>
                    <strong>Name:</strong>&nbsp;
                    {selectedPatient?.full_name || "N/A"}
                  </p>
                </Col>
                <Col sm="6">
                  <p>
                    <strong>NAKBHO Health ID:</strong>&nbsp;
                    {selectedPatient?.health_id || "N/A"}
                  </p>
                </Col>
              </Row>
              <Row>
                <Col sm="6">
                  <p>
                    <strong>Gender:</strong>&nbsp;
                    {selectedPatient?.gender
                      ? selectedPatient.gender.charAt(0).toUpperCase() +
                        selectedPatient.gender.slice(1)
                      : "N/A"}
                  </p>
                </Col>
                <Col sm="6">
                  <p>
                    <strong>Age:</strong> {selectedPatient?.age || "N/A"}
                  </p>
                </Col>
              </Row> */}
              <div className="mt-4">
                <Card className="patient-card-background">
                  <div className="p-2">
                    <div className="p-2 d-flex tw-space-x-2">
                      <S3ImageLoader
                        fileName={selectedPatient.profile_picture}
                        alt=""
                        className="patient-pic img-60"
                        fallbackSrc={errorProfile}
                      />
                      <div className="ps-3">
                        <h6 className="mb-0">
                          <strong>
                            {selectedPatient.first_name}{" "}
                            {selectedPatient.middle_name}{" "}
                            {selectedPatient.last_name}
                          </strong>
                        </h6>
                        <small
                          style={{
                            fontSize: "12px",
                            textTransform: "capitalize",
                          }}
                        >
                          {selectedPatient.gender},{" "}
                          {moment(selectedPatient.dob).format("DD MMM YYYY")}{" "}
                          Age {calculateAge(selectedPatient.dob)}
                        </small>
                        <div className="patient-healthId-text tw-min-w-max">
                          {selectedPatient.health_id
                            ?.match(/.{1,4}/g)
                            .join(" ")}
                        </div>
                      </div>
                      <div className="row ps-3">
                        <div className="col-md-6">
                          <div className="d-flex align-items-center">
                            <div className="p-0 rounded-circle me-2">
                              <FiPhoneCall />
                            </div>
                            <span style={{ fontSize: "12px" }}>
                              {selectedPatient.phone_code}{" "}
                              {selectedPatient.mobile}
                            </span>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="d-flex align-items-center">
                            <div className="p-0 rounded-circle me-2">
                              <TfiEmail />
                            </div>
                            <span style={{ fontSize: "12px" }}>
                              {selectedPatient.email}
                            </span>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="d-flex align-items-center">
                            <div className="p-0 rounded-circle me-2">
                              <FaLocationDot />
                            </div>
                            <small>{selectedPatient.address}</small>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Card>
              </div>

              {/* Report Upload */}
              <Form.Group className="my-3">
                <Form.Label>Report Upload</Form.Label>
                <Form.Control
                  type="file"
                  ref={fileInputRef}
                  accept=".pdf, image/jpeg, image/jpg, image/png"
                  onChange={(e) => {
                    const selected = e.target.files[0];
                    if (selected) {
                      const allowedTypes = [
                        "application/pdf",
                        "image/jpeg",
                        "image/jpg",
                        "image/png",
                      ];
                      if (!allowedTypes.includes(selected.type)) {
                        setErrors((prev) => ({
                          ...prev,
                          file: "Only PDF or image files (jpg, jpeg, png) are allowed.",
                        }));
                        setFile(null);
                        // Clear the file input's value
                        if (fileInputRef.current) {
                          fileInputRef.current.value = "";
                        }
                        return;
                      }
                      setErrors((prev) => ({ ...prev, file: "" }));
                      setFile(selected);
                    }
                  }}
                  disabled={isUploading}
                />
                <span className="mt-2 text-muted small">
                  Allowed file types: PDF, JPG, JPEG, PNG
                </span>
                {errors.file && (
                  <div className="mt-1 text-danger">{errors.file}</div>
                )}
              </Form.Group>
            </>
          )}

          {/* Submit Button */}
          <div className="gap-2 d-flex justify-content-end">
            <Button
              variant="primary"
              type="submit"
              disabled={isUploading || !selectedPatient}
            >
              {isUploading ? "Uploading..." : "Submit"}
            </Button>
            <Button
              variant="secondary"
              onClick={resetReport}
              disabled={isUploading || !selectedPatient}
            >
              Reset
            </Button>
          </div>
        </Form>
      </CardBody>
      <SearchPatientModel
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        isPatientModal={isPatientModal}
        setIsPatientModal={setIsPatientModal}
        handleSelectPatient={(patient) => {
          setSelectedPatient(patient);
          setIsPatientModal(false);
        }}
      />
    </Card>
  );
};

export default NewReport;
